import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { ChangeBtn } from 'src/components/atoms/input/buttons'
import QuantitySelect from 'src/components/atoms/configurator/QuantitySelect'
import PriceHeadline from 'src/components/atoms/configurator/PriceHeadline'
import { Props } from './ProductDetailCard'
import { media } from '../../../utils'
import ReactHtmlParser from 'react-html-parser';

interface State {
  openCollapse: boolean
  count: number
}

@inject('confStore')
@observer
export default class ProductDetailCardCollapse extends React.Component<
  Props,
  State
> {
  static defaultProps = {
    count: 1,
    quantityFactor: 1
  }

  render() {
    const {
      confStore,
      count,
      maxQuantity,
      minQuantity,
      product,
      onQuantitySelect,
      onSelect,
      quantityFactor,
      quantityselect,
      selected,
      setHighlight
    } = this.props

    return (
      <CollapseWrapper>
        <Close onClick={() => setHighlight(false)}>x</Close>
        <ImageContainer
          whiteBg={['FLOWER', 'COFFIN', "URN"].includes(product.productType)}>
          <LazyLoadImage
            alt='product_image'
            src={product.photos[0]}
            effect='blur'
            height='100%'
          />
        </ImageContainer>
        <DataContainer>
          <PriceHeadline
            border='none'
            service={product ? product.name : 'Lädt..'}
            price={confStore.calculateProductPrice(product, count)}
          />
          <p>{product.shortDescription}</p>
          <ProductDescription>
            {ReactHtmlParser(product.longDescription)}
          </ProductDescription>
          <ControlsContainer>
            <ChangeBtn
              id='selectOrUnselectProduct'
              onClick={() => onSelect(product, quantityFactor * count)}>
              <div>{selected ? 'Entfernen' : 'Auswählen'}</div>
            </ChangeBtn>
            {quantityselect && (
              <QuantitySelect
                style={{ position: 'static', height: 31 }}
                value={count}
                minValue={minQuantity || quantityFactor}
                maxValue={maxQuantity || product.prices.length * quantityFactor}
                steps={quantityFactor}
                hidden={!selected}
                onSelect={(c) => onQuantitySelect(product, c)}
              />
            )}
          </ControlsContainer>
        </DataContainer>
      </CollapseWrapper>
    )
  }
}

const CollapseWrapper = styled.div`
  display: flex;
  align-items: stretch;
  position: relative;
  grid-column: 1/-1;
  background-color: #d5e4e6;
  margin: 30px;
  padding: 15px;
  z-index: 99999;
  ${media.desktop` flex-direction: column; `}
  ${media.tablet` margin: 30px 15px; `}
`

const Close = styled.button`
  position: absolute;
  right: 3px;
  top: 3px;
  font-size: 18px;
  font-weight: bold;
  appearance: none;
  border: none;
  background: transparent;
  z-index: 9999;
`

const ImageContainer = styled.div`
  width: 40%;
  background: ${(props) => (props.whiteBg ? 'white' : '#d5e4e6')};
  text-align: center;
  span {
    padding: 15px;
  }
  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
  ${media.desktop`
    height: 40%;
    width: 100%;
  `}
`

const DataContainer = styled.div`
  width: 60%;
  padding: 15px 15px 15px 30px;
  vertical-align: top;
  ${media.desktop`
    width: 100%;
    height: 60%;
    padding: 15px;
  `}
`

const ProductDescription = styled.div`
  & > ul {
    padding-left: 20px;
    list-style: none;

    li {
      position: relative;
      margin: 10px 0;
      padding-left: 30px;
      font-size: 15px;

      &:before {
        position: absolute;
        left: -1px;
        content: '';
        font-family: 'Font Awesome 5 Free';
        font-weight: 700;
        color: #9abbbf;
      }
    }
  }
  ${media.desktop` & > ul { padding-left: 0; } `}
`

const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  height: 31px;
  width: 170px;
  margin: 15px auto;
`



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/ProductDetailCardCollapse.tsx